/* tslint:disable */
/* eslint-disable */
/**
 * Adgang API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Language } from './Language';
import {
    LanguageFromJSON,
    LanguageFromJSONTyped,
    LanguageToJSON,
    LanguageToJSONTyped,
} from './Language';
import type { TranslationGroupType } from './TranslationGroupType';
import {
    TranslationGroupTypeFromJSON,
    TranslationGroupTypeFromJSONTyped,
    TranslationGroupTypeToJSON,
    TranslationGroupTypeToJSONTyped,
} from './TranslationGroupType';

/**
 * 
 * @export
 * @interface TranslationResponse
 */
export interface TranslationResponse {
    /**
     * 
     * @type {TranslationGroupType}
     * @memberof TranslationResponse
     */
    groupType?: TranslationGroupType;
    /**
     * 
     * @type {Language}
     * @memberof TranslationResponse
     */
    languageId?: Language;
    /**
     * 
     * @type {any}
     * @memberof TranslationResponse
     */
    groupKey?: any | null;
    /**
     * 
     * @type {string}
     * @memberof TranslationResponse
     */
    groupText?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TranslationResponse
     */
    text?: string | null;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof TranslationResponse
     */
    placeholders?: { [key: string]: string; } | null;
}



/**
 * Check if a given object implements the TranslationResponse interface.
 */
export function instanceOfTranslationResponse(value: object): value is TranslationResponse {
    return true;
}

export function TranslationResponseFromJSON(json: any): TranslationResponse {
    return TranslationResponseFromJSONTyped(json, false);
}

export function TranslationResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): TranslationResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'groupType': json['groupType'] == null ? undefined : TranslationGroupTypeFromJSON(json['groupType']),
        'languageId': json['languageId'] == null ? undefined : LanguageFromJSON(json['languageId']),
        'groupKey': json['groupKey'] === undefined ? undefined : json['groupKey'] === null ? null : json['groupKey'],
        'groupText': json['groupText'] === undefined ? undefined : json['groupText'] === null ? null : json['groupText'],
        'text': json['text'] === undefined ? undefined : json['text'] === null ? null : json['text'],
        'placeholders': json['placeholders'] === undefined ? undefined : json['placeholders'] === null ? null : json['placeholders'],
    };
}

export function TranslationResponseToJSON(json: any): TranslationResponse {
    return TranslationResponseToJSONTyped(json, false);
}

export function TranslationResponseToJSONTyped(value?: TranslationResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'groupType': TranslationGroupTypeToJSON(value['groupType']),
        'languageId': LanguageToJSON(value['languageId']),
        'groupKey': value['groupKey'],
        'groupText': value['groupText'],
        'text': value['text'],
        'placeholders': value['placeholders'],
    };
}

